import React, { PropsWithChildren, Suspense } from "react";
import ErrorBoundary from "../../components/ErrorBoundary/ErrorBoundary";
import ErrorBoundaryConfig from "../../ErrorBoundaryConfig";

interface IAsyncBoundry extends PropsWithChildren {
  errorFallback?: React.ReactNode;
  suspenseFallback: React.ReactNode;
}

export const AsyncBoundary: React.FC<IAsyncBoundry> = ({ children, errorFallback, suspenseFallback }) => {
  return (
    <ErrorBoundary fallback={errorFallback} {...ErrorBoundaryConfig}>
      <Suspense fallback={suspenseFallback}>{children}</Suspense>
    </ErrorBoundary>
  );
};
